import Barba from 'barba.js';

import Component from '../base/component';
import Field from './field';
import { qs, qsa, toggleClass, data } from '../base/dom-utils';

class StepsForm extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.$els.steps = qsa(this.options.steps, this.$el);
        this.$els.pag = qs(this.options.pag, this.$el);
        this.$els.back = qs(this.options.back, this.$el);
        this.$els.fields = qsa(this.options.field, this.$el);
        this.$els.radio = qsa('.o-radio input', this.$el);
        this.$els.progress = qs(this.options.progress, this.$el);
        this.$els.counter = qs(this.options.counter, this.$el);
        this.$els.counterTot = qs(this.options.counterTot, this.$els.counter);
        this.$els.counterCurr = qs(this.options.counterCurr, this.$els.counter);
        this.$els.errors = qs(this.options.errors, this.$el);
        this.$els.submit = qs(this.options.submit, this.$el);

        this._transEndEventName = this.options.transitionEndNames[ Modernizr.prefixed( 'transition' ) ];
        this._hasTransitionSupport = { transitions: Modernizr.csstransitions };

        this.handleProgressEnd = this.handleProgressEnd.bind(this);

    }

    beforeInit() {

        this.delegate('click', this.options.pag, (e) => {
            e.preventDefault();

            const currState = this.getState('currentStep');
            this.setState('currentStep', currState + 1);
        });

        this.delegate('click', this.options.back, (e) => {
            e.preventDefault();

            const currState = this.getState('currentStep');
            this.setState('currentStep', currState - 1);
        });

        this.$el.addEventListener('submit', (e) => {
            e.preventDefault();

            const currStep = parseInt(this.getState('currentStep'), 10);
            const totStep = parseInt(this.getState('totalStep'), 10);

            const isFilled = (currStep === totStep);

            if (isFilled) {


                let formData = this.$els.fields.map((el) => { //eslint-disable-line arrow-body-style
                    return encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value);
                }).join('&');

                const checkedRadio = this.$els.radio.find((el) => el.checked);
                if (checkedRadio) {
                    formData += '&' + encodeURIComponent(checkedRadio.id) + '=' + encodeURIComponent(checkedRadio.value);
                }

                const xhr = new XMLHttpRequest();
                xhr.open('POST', this.$el.getAttribute('action'));
                xhr.onreadystatechange = () => {
                    if (xhr.readyState > 3 && xhr.status === 200) {
                        //convert to JSON
                        try {
                            const response = JSON.parse(xhr.responseText);
                            if (response.ok) {
                                Barba.Pjax.goTo(response.thankyouUrl);
                            } else {
                                Barba.Pjax.goTo(response.errorUrl);
                            }
                        } catch (err) {
                            console.error(err);
                            this.printErrors('Error submitting the form');
                        }
                    } else {
                        this.printErrors('Error submitting the form');
                    }
                };

                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.send(formData);

            } else {
                this.setState('currentStep', currStep + 1);
            }

        }, false);

        this.on('change:currentStep', (newStep, oldStep) => {
            // to validate
            const nextStep = this.$els.steps[newStep - 1];
            const formField = qs(this.options.field, nextStep);
            const isPrev = newStep < oldStep;

            const type = data('approve', formField);

            this.$els.fields.forEach((field, i) => {

                if (i !== this.getState('currentStep') - 1) {
                    field.setAttribute('readonly', '');
                } else {
                    field.removeAttribute('readonly');
                }
            });

            // old field
            const oldFieldId = oldStep + '::field';
            const oldField = this.$refs[oldFieldId];

            const isValid = oldField ? oldField.validateField() : true;

            if (isPrev || isValid) {

                this.cleanErrors();

                if (!this.$refs[newStep + '::field']) {
                    this.setRef(newStep + '::field', Field, formField, {
                        type: type.length ? type : ''
                    });
                }

                toggleClass(this.$els.steps[newStep - 1], 'is-current', true);

                if (oldStep) {
                    toggleClass(this.$el, 'is-changing', true);
                    toggleClass(this.$els.steps[oldStep - 1], 'is-current', false);

                    if ( this._hasTransitionSupport.transitions ) {
                        this.$els.progress.addEventListener( this._transEndEventName, this.handleProgressEnd );
                    }
                }

                this.updateCounter(newStep).then(() => {
                    this.$els.counter.removeChild(this.$els.counterNext);
                });

                const totalStep = this.getState('totalStep');
                this.$els.progress.style.width = parseInt(newStep, 10) * ( 100 / totalStep ) + '%';

                this.$els.counterCurr.innerHTML = '0' + newStep;

            } else {

                const errorMessage = oldField.getState('errors').join(', ');
                this.printErrors(errorMessage);

                this.$els.fields[oldStep - 1].removeAttribute('readonly');

                this.setState('currentStep', oldStep, true);
            }

        });

        this.on('change:totalStep', (newStep) => {

            if (newStep) {
                this.$els.counterTot.innerHTML = '0' + newStep;
            }

        });

    }

    handleProgressEnd() {

        const current = this.state.get('currentStep');
        const total = this.state.get('totalStep') + 1;

        const isFormFilled = current === total;
        const isLastForm = total - current === 1;

        if (current > 1) {
            toggleClass(this.$els.back, 'is-visible', true);
        } else {
            toggleClass(this.$els.back, 'is-visible', false);
        }

        toggleClass(this.$els.submit, 'is-visible', isLastForm);
        toggleClass(this.$els.pag, 'u-hidden', isLastForm);
        // toggleClass(this.$el, 'is-last', isLastForm);

        const step = this.$els.steps[current - 1];
        const field = qs(this.options.field, step);

        if (!field.value.length) {
            field.focus();
        }

        if (isFormFilled) {
            this.$el.submit();

        } else {

            // remove transition listener
            if ( this._hasTransitionSupport.transitions ) {
                this.$els.progress.removeEventListener(this._transEndEventName, this.handleProgressEnd);
            }

            toggleClass(this.$el, 'is-changing', false);
        }

    }

    printErrors(errorMessage) {
        this.$els.errors.innerHTML = errorMessage;
        toggleClass(this.$els.errors, 'is-visible', true);
    }

    cleanErrors() {
        this.$els.errors.innerHTML = '';
        toggleClass(this.$els.errors, 'is-visible', true);
    }

    updateCounter(currentStep) {

        return new Promise((resolve) => {
            const nextCounter = this.$els.counterNext = document.createElement('span');

            toggleClass(nextCounter, this.options.counterNext, true);
            nextCounter.innerHTML = '0' + currentStep;

            // insert it in the DOM
            this.$els.counter.appendChild(nextCounter);

            resolve();
        });

    }


    getInitialState() {
        return {
            totalStep: this.$els.steps.length,
            currentStep: 1
        };
    }

    destroy() {

        this.setState('currentStep', 1, true);

        toggleClass(this.$els.back, 'is-visible', false);
        toggleClass(this.$els.submit, 'is-visible', false);

        this.$els.steps.forEach((step) => {
            toggleClass(step, 'is-current', false);
        });

        this.$els.fields.forEach((field) => {
            field.value = '';
        });

        return super.destroy();
    }

    getDefaultOptions() {
        return {
            steps: '.o-form__step',
            pag: '.o-form__pag',
            back: '.o-form__back',
            progress: '.o-form__progress',
            field: '.o-form__field',
            counter: '.o-form__counter',
            counterTot: '.o-form__tot',
            counterCurr: '.o-form__curr',
            counterNext: 'o-form__next',
            errors: '.o-form__error',
            submit: '.o-form__submit',
            transitionEndNames: {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd',
                msTransition: 'MSTransitionEnd',
                transition: 'transitionend'
            }
        };
    }
}

export default StepsForm;


/** WEBPACK FOOTER **
 ** ./components/steps-form.js
 **/